export default "__VITE_ASSET__fEqOO8ZL__"